import { render, staticRenderFns } from "./DiagnosticTableFilters.vue?vue&type=template&id=21a2ce96&"
import script from "./DiagnosticTableFilters.vue?vue&type=script&lang=js&"
export * from "./DiagnosticTableFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports